import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import { auth,db } from '../firebase'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    assistants:[],
    osimf:[]
  },
  mutations: {
    setAssistant(state, assist){
      state.assistants = assist
    },
    editAssistant(state,datas){
      state.assistants[datas.position].member = datas.data.member
      state.assistants[datas.position].typeMember = datas.data.typeMember
      state.assistants[datas.position].name = datas.data.name
      state.assistants[datas.position].lastname = datas.data.lastname
      state.assistants[datas.position].documentType = datas.data.documentType

      state.assistants[datas.position].document = datas.data.document
      state.assistants[datas.position].gender = datas.data.gender
      state.assistants[datas.position].country = datas.data.country
      state.assistants[datas.position].cityPerson = datas.data.cityPerson
      state.assistants[datas.position].address = datas.data.address
      state.assistants[datas.position].email = datas.data.email
      state.assistants[datas.position].phone = datas.data.phone
      state.assistants[datas.position].companies = datas.data.companies
      state.assistants[datas.position].company = datas.data.company
      state.assistants[datas.position].jobtitle = datas.data.jobtitle
      state.assistants[datas.position].countryCompany = datas.data.countryCompany
      state.assistants[datas.position].cityCompany = datas.data.cityCompany
      state.assistants[datas.position].addressCompany = datas.data.addressCompany
      state.assistants[datas.position].typeInvoice = datas.data.typeInvoice
      state.assistants[datas.position].nameToInvoice = datas.data.nameToInvoice
      state.assistants[datas.position].documentInvoice = datas.data.documentInvoice
      state.assistants[datas.position].addressInvoice = datas.data.addressInvoice
      state.assistants[datas.position].emailInvoice = datas.data.emailInvoice
      state.assistants[datas.position].languaje = datas.data.languaje

      state.assistants[datas.position].confirm = datas.data.confirm
      state.assistants[datas.position].countFirstEmail = datas.data.countFirstEmail
      
    },
    deleteAssistant(state, data){
      state.assistants.splice(data, 1) 
    },
    setOcimf(state, osimf){
      state.osimf = osimf
    },
    editOsimf(state,datas){

      state.osimf[datas.position].documentType = datas.data.documentType
      state.osimf[datas.position].document = datas.data.document
      state.osimf[datas.position].name = datas.data.name
      state.osimf[datas.position].lastname = datas.data.lastname
      state.osimf[datas.position].email = datas.data.email
      state.osimf[datas.position].phone = datas.data.phone
      state.osimf[datas.position].country = datas.data.country
      state.osimf[datas.position].cityPerson = datas.data.cityPerson
      state.osimf[datas.position].address = datas.data.address
      state.osimf[datas.position].company = datas.data.company
      state.osimf[datas.position].job = datas.data.job
      state.osimf[datas.position].confirmed = datas.data.confirmed
      state.osimf[datas.position].countFirst = datas.data.countFirst
    },
    deleteOsimf(state, data){
      state.osimf.splice(data, 1)
    }
  },
  actions: {

    checkAuth({commit}){
      auth.onAuthStateChanged(function(user){
        if(user){
          commit("user/setUser", user)
        }else{
          commit("user/setUser",null);
        }
      })

    },
    async fetchAssistents({commit}){
        await db.collection("assistant").orderBy("dateAt","desc")
        .onSnapshot((snapshot)=>{
          snapshot.docChanges().forEach((change)=>{
            if (change.type === "added") {
              
              let arreglo = this.state.assistants

              

              arreglo.push({...change.doc.data(), email:change.doc.data().email})
              commit("setAssistant", arreglo)

            }
            if (change.type === "modified") {

              let arreglo = this.state.assistants
              let existe =arreglo.findIndex(x=>x.email == change.doc.data().email)
              let templates = {
                position:existe,
                data: change.doc.data()
              }
              commit("editAssistant",templates)
              
            }
            if (change.type === "removed") {

              let arreglo = this.state.assistants
              let existe =arreglo.findIndex(x=>x.email == change.doc.data().email)
              /*
              
              let templates = {
                position:existe,
                data: change.doc.data()
              }*/
              commit("deleteAssistant",existe)
              //console.log(change.doc.data())

            }
          })
        })
    },
    async fetchOcimf({commit}){
      await db.collection("ocimf").orderBy("createdAt","desc")
          .onSnapshot((snapshot)=>{
            snapshot.docChanges().forEach((change)=>{
              if (change.type === "added") {
                let arreglo = this.state.osimf
                arreglo.push({...change.doc.data(), email:change.doc.data().email})
                commit("setOcimf", arreglo)

              }
              if (change.type === "modified") {

                let arreglo = this.state.osimf
                let existe =arreglo.findIndex(x=>x.email == change.doc.data().email)
                let templates = {
                  position:existe,
                  data: change.doc.data()
                }
                commit("editOsimf",templates)

              }
              if (change.type === "removed") {

                let arreglo = this.state.osimf
                let existe =arreglo.findIndex(x=>x.email == change.doc.data().email)
                commit("deleteOsimf",existe)

              }
            })
          })
    },
    
  },
  modules: {
    user
  },
  getters:{
    all(state){
      return state.assistants
    },
    allOcimf(state){
      return state.osimf
    }
  }
})

export default store;

store.dispatch("checkAuth")
store.dispatch("fetchAssistents")
store.dispatch("fetchOcimf")
